(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Menu drawer */
  document.addEventListener('DOMContentLoaded', () => {
    const toggle = document.querySelector('[data-drawer-toggle]');
    const drawer = document.querySelector('[data-drawer]');
    const overlay = document.querySelector('[data-drawer-overlay]');
    const close = document.querySelector('[data-drawer-close]');

    if (!toggle || !drawer) return;

    function open() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function shut() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', open);
    close.addEventListener('click', shut);
    overlay.addEventListener('click', shut);
  });

  /* SP: Search panel toggle */
  document.addEventListener('DOMContentLoaded', () => {
    const searchToggle = document.querySelector('[data-search-toggle]');
    const searchPanel = document.querySelector('[data-search-panel]');
    const searchInput = document.querySelector('[data-search-panel-input]');

    if (!searchToggle || !searchPanel) return;

    function openSearch() {
      searchPanel.removeAttribute('hidden');
      // 次フレームで is-open を付けてアニメーション発火
      requestAnimationFrame(() => {
        searchPanel.classList.add('is-open');
      });
      searchToggle.setAttribute('aria-expanded', 'true');
      // パネル表示後に入力欄にフォーカス
      setTimeout(() => searchInput?.focus(), 200);
    }

    function closeSearch() {
      searchPanel.classList.remove('is-open');
      searchToggle.setAttribute('aria-expanded', 'false');
      // アニメーション完了後に hidden を戻す
      setTimeout(() => {
        if (!searchPanel.classList.contains('is-open')) {
          searchPanel.setAttribute('hidden', '');
        }
      }, 300);
    }

    searchToggle.addEventListener('click', () => {
      if (searchPanel.classList.contains('is-open')) closeSearch();
      else openSearch();
    });

    // Esc でクローズ
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchPanel.classList.contains('is-open')) closeSearch();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
